import { CommonModels } from './common.models';
import { DocumentModels } from './document.models';
import { HealthModels } from './health.models';
import { PolicyModels } from './policy.models';
import { TableModels } from './table.models';

export namespace RequestModels {
  import InsuranceTypeEnum = CommonModels.InsuranceTypeEnum;

  export interface CreateTerminationRequest {
    files: File[];
    fileIds: number[];
    type: PolicyModels.TerminationTypeEnum;
    category: number;
    effectDate: string;
    policyId: number;
    comments: string;
    situationChange?: PolicyModels.SituationChangeEnum;
  }

  export interface UpdateTerminationRequest {
    effectDate: string;
    requestId: number;
    state: RequestStateEnum;
    reject?: RequestRejectEnum;
    rejectComments: string;
    comments: string;
    situationChange?: PolicyModels.SituationChangeEnum;
    templateId: number;
    emailBody: string;
    emailSubject: string;
    files: File[];
    clientEmail?: string;
    agencyEmail?: string;
    sendByPost?: boolean;
  }

  export interface TerminationRequestResponse {
    current: TerminationRequest;
    history: TerminationRequest[];
    rejects: RequestRejectEnum[];
  }

  export interface TerminationRequest {
    emailTemplate?: number;
    category?: HealthModels.TerminationCategoryEnum;
    demandeDeMaintien?: boolean;
    creationDate: Date;
    lastStateCreationDate: Date;
    lastStateId: number;
    state: RequestModels.RequestStateEnum;
    type: PolicyModels.TerminationTypeEnum;
    situationChange?: PolicyModels.SituationChangeEnum;
    effectDate: Date;
    rejects: RequestRejectEnum[];
    rejectComments: string;
    comments: string;
    id: number;
    fragments: DocumentModels.FragmentData[];
    rejectFileUrl?: string;
    clientEmail?: string;
    agencyEmail?: string;
    initiatedByAdmin: boolean;
  }

  export interface RequestsPaginatedRequest
    extends TableModels.PaginatedRequest {
    state?: RequestStateEnum;
    type?: RequestTypeEnum;
    insuranceType?: InsuranceTypeEnum;
    policyId?: number;
  }

  export interface RequestTableRow {
    requestId: number;
    creationDate: Date;
    state: RequestModels.RequestStateEnum;
    type: RequestModels.RequestTypeEnum;
    insuranceType?: InsuranceTypeEnum;
    policyInfo?: PolicyModels.PolicyInfo;
  }

  export enum RequestStateEnum {
    Requested = 1,
    Cancelled = 2,
    Rejected = 3,
    Accepted = 4,
    Handled = 5,
    Temporary = 6,
    PreAccepted = 7,
    Processing = 8,
    Error = 9,
    Suspended = 10,
  }

  export enum RequestTypeEnum {
    Termination = 1,
    Avenant = 2,
    MonthlySlips = 3,
  }

  export enum RequestRejectEnum {
    Autre = 1,
    DocumentInvalide = 2,
    DocumentManquant = 3,
    DocumentIllisible = 4,
    QuittanceImpayee = 5,
    ContratDejaResilieNpp = 6,
    ContratDejaResilieSinistralite = 7,

    AncienneteMoinsUnAn = 101,
    SouscripteurDifferent = 102,
    DemandePassantParAssureNonAssureur = 103,

    LoiChatelHorsDelai = 201,
    L11312HorsDelai = 202,

    MotifNonValable = 401,

    AucuneRevalorisation = 501,
    RevalorisationHorsDelai = 502,
    AugmentationSuiteAMalus = 503,

    VehiculeEnPanne = 601,
    NonUtilisationDuVehicule = 602,
    AucunMotif = 603,
  }
}
